import { render } from "./ContactBookOverflowMenuV2.vue?vue&type=template&id=de0f8d2a&ts=true"
import script from "./ContactBookOverflowMenuV2.vue?vue&type=script&lang=ts"
export * from "./ContactBookOverflowMenuV2.vue?vue&type=script&lang=ts"

import exportComponent from "/private/var/folders/qk/zz5x885n487_vn5fy4hxyvwh0000gn/T/deploy/contacts-ui/0097ac0aca88fbc4bb68850fcea5360bca02b5df/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.4.31_vue@3.4.31_typescript@5.5.3__webpack@5.92.1_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__